<script setup>
    const props = defineProps({
        errors: Array,
        iconImageFile: Object,
        iconImagePreview: String,
    })
    const emits = defineEmits(['onIconImageChange', 'onRemoveIconImage'])
</script>

<template>
    <b-field :label="$t('trainings.fields.icon.name')" horizontal custom-class="mb-3"
             :type="errors ? 'is-danger' : null"
             :message="errors ? errors[0] : null">
        <div class="is-fullwidth">
            <div class="file has-name is-fullwidth mb-3">
                <label class="file-label">
                    <input class="file-input" type="file" accept="image/*" @change="emits('onIconImageChange', $event)">
                    <span class="file-cta">
                    <span class="file-icon"><i class="mdi mdi-image"></i></span>
                    <span class="file-label">{{ $t('file_upload.select_image') }}...</span>
                </span>
                    <span class="file-name" v-if="iconImageFile">{{ iconImageFile.name }}</span>
                    <span class="file-name" v-else>{{ $t('file_upload.no_selected_file') }}</span>
                </label>
            </div>

            <div v-if="iconImagePreview" class="box" style="width: fit-content;">
                <figure class="image mb-2">
                    <img :src="iconImagePreview" class="icon-image">
                </figure>
                <button type="button" class="button is-danger is-light is-small" @click="emits('onRemoveIconImage')">
                    <b-icon icon="delete" size="is-small"></b-icon>
                </button>
            </div>
        </div>
    </b-field>
</template>

<style scoped>
.icon-image {
    max-height: 150px;
    width: auto;
    object-fit: contain;
}
</style>
